export const InboundTrack = 'inbound_tracking';
export const OutboundTrack = 'outbound_tracking';
export const SingleOrderCreate = 'single_order';
export const BulkOrderCreate = 'bulk_order';
export const InboundHistory = 'inbound_history';
export const OutboundHistory = 'outbound_history';
export const ImportList = 'import_list';

export const Actions = {
  export: 'export',
  sendTrackingUrl: 'send_tracking_url',
  view: 'view',
  create: 'create',
  print: 'print',
  edit: 'edit',
  retry: 'retry',
  download: 'download',
  viewFile: 'view_file',
  printShippingDoc: 'print_shipping_doc'
}